import { FullscreenCarousel, TOnSlideChangeParams } from '@cian/frontend-fullscreen-carousel-component';
import * as React from 'react';

import { prepareSlides } from './utils';

export interface IFullscreenSlide {
  node: React.ReactNode;
  thumbnailNode: React.ReactNode;
}

export enum EMediaType {
  /** Изображение **/
  Image = 'image',
  /** Видео **/
  Video = 'video',
  Mortgage = 'mortgage',
}

export interface IMediaItemDesktopSchema {
  /** Текст для атрибута alt **/
  alt: string;
  /** Ссылка на исходное медиа **/
  fullUrl: string;
  /** ID медиа **/
  id: number;
  /** Главное изображение **/
  isPrimaryImage?: boolean | null;
  /** Тип медиа **/
  mediaType: EMediaType;
  /** Ссылка на превью **/
  thumbnailUrl: string;
  /** Ссылка на YouTube **/
  videoUrl?: string | null;
  isFloorPlan?: boolean;
  polygonPath?: string | null;
}

export interface IFullscreenGalleryProps {
  header: React.ReactNode;
  images: IMediaItemDesktopSchema[];
  title?: string;
  defaultSlideIndex: number | undefined;
  onClose(): void;
  onOpen?(): void;
  onSlideChange(params: TOnSlideChangeParams): void;
}

export interface IFullscreenGalleryState {
  slides: IFullscreenSlide[];
}

export class FullscreenGallery extends React.Component<IFullscreenGalleryProps, IFullscreenGalleryState> {
  public state = {
    slides: prepareSlides(this.props.images),
  };

  public componentDidMount() {
    const { onOpen } = this.props;

    if (onOpen) {
      onOpen();
    }
  }

  public render() {
    const { defaultSlideIndex, onClose, onSlideChange, header } = this.props;
    const { slides } = this.state;

    return (
      <FullscreenCarousel
        slides={slides}
        media={[
          {
            minWidth: 1024,
            maxWidth: Infinity,
            options: {
              contentOptions: {
                headerContent: header,
              },
            },
          },
        ]}
        onClose={onClose}
        defaultCurrentSlide={defaultSlideIndex}
        onSlideChange={onSlideChange}
      />
    );
  }
}
